import { Tooltip } from '@cian/ui-kit';
import { type ISVGIconProps, IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import {
  PictogramB2BSpeciality40,
  PictogramBuildingBuilding40,
  PictogramBuildingCommissioning40,
  PictogramProductTrust40,
} from '@cian/ui-kit-design-tokens/pictograms';

import { type FC } from 'react';

import styles from './Fact.css';

export type FactTypes = 'foundationYear' | 'inProgress' | 'onTime' | 'completed';

type FactProps = {
  title: string;
  text: string;
  description: string | undefined;
  type: FactTypes;
};

export const Fact: FC<FactProps> = ({ title, type, text, description }) => {
  const Icon = ((): FC<ISVGIconProps> => {
    switch (type) {
      case 'foundationYear':
        return PictogramBuildingBuilding40;
      case 'inProgress':
        return PictogramB2BSpeciality40;
      case 'onTime':
        return PictogramProductTrust40;
      case 'completed':
        return PictogramBuildingCommissioning40;
    }
  })();

  return (
    <li className={styles['fact']} data-testid="Fact">
      <div className={styles['icon']}>
        <Icon color="icon-warning-default" data-testid={`Fact-icon--${type}`} />
      </div>
      <div className={styles['content']} data-testid="Fact-content">
        <span className={styles['title']} data-testid="Fact-content-title">
          {title}
        </span>
        <span className={styles['text']} data-testid="Fact-content-text-container">
          {text}
          {description && (
            <span className={styles['info']} data-testid="Fact-content-icon-container">
              <Tooltip
                theme="white"
                title={
                  <span className={styles['tooltip-text']} data-testid="Fact-content-icon-tooltip">
                    {description}
                  </span>
                }
              >
                <div className={styles['inner-info']} data-testid="Fact-content-icon-wrapper">
                  <IconFunctionalInformationCircle16 data-testid="Fact-content-icon" />
                </div>
              </Tooltip>
            </span>
          )}
        </span>
      </div>
    </li>
  );
};
